import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from './../components/Layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home-screen',
    name: 'HomeScreen',
    component: () => import('./../views/HomeScreen.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('./../views/UserLogin.vue'),
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        redirect: 'logs',
      },
      {
        path: '/logs/:id?',
        name: 'LogsView',
        component: () => import('./../views/LogsView.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/user-profile',
        name: 'UserProfile',
        component: () => import('./../views/UserProfile.vue'),
      },
      {
        path: '/regedit',
        name: 'RegEdit',
        component: () => import('./../views/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/bulk',
        name: 'BulkRegistry',
        component: () => import('./../views/BulkRegistry.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/cert-generator',
        name: 'Certs',
        component: () => import('./../views/ManageCerts.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/star-catalogue',
        name: 'Stars',
        component: () => import('./../views/ManageStars.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/admin/orders/:id?',
        name: 'ManageOrders',
        component: () => import('./../views/ManageOrders.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/admin/mizodia-orders',
        name: 'ManageMizodiaOrders',
        component: () => import('./../views/ManageMizodiaOrders.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/amazon-prime/orders/:id?',
        name: 'ManageAmazonOrders',
        component: () => import('./../views/ManageAmazonOrders.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/mizodia/custom',
        name: 'MizodiaCustom',
        component: () => import('./../views/ManageMizodiaCustom.vue'),
        meta: { requiresAuth: true, roles: ['mizodia'] },
      },
      {
        path: '/mizodia/fingerprints',
        name: 'MizodiaFingerprint',
        component: () => import('./../views/ManageMizodiaFingerprint.vue'),
        meta: { requiresAuth: true, roles: ['mizodia'] },
      },
      {
        path: '/mizodia/print-extractor',
        name: 'MizodiaPrintExtractor',
        component: () => import('./../views/CustomPrintExtractor.vue'),
        meta: { requiresAuth: true, roles: ['mizodia'] },
      },
      {
        path: '/mizodia/engraving-mask',
        name: 'MizodiaEngravingMask',
        component: () => import('./../views/MizodiaEngravingMask.vue'),
        meta: { requiresAuth: true, roles: ['mizodia'] },
      },
      {
        path: '/mizodia/birth-flower-bouquet',
        name: 'MizodiaBirthFlowerBouquet',
        component: () => import('./../views/MizodiaBirthFlowerBouquet.vue'),
        meta: { requiresAuth: true, roles: ['mizodia'] },
      },
      {
        path: '/skymap-products/poster',
        name: 'CustomPoster',
        component: () => import('../views/SkymapProducts.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/skymap-products/jewelry',
        name: 'CustomJewelry',
        component: () => import('../views/SkymapProducts.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/faq',
        name: 'Faq',
        component: () => import('./../views/Faq.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/*',
    name: 'NotFound',
    component: () => import('./../views/NotFound.vue'),
  },
]

var router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
})

export default router
